import { Box, Stack, styled, Typography } from '@mui/material'
import { useState, type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { COLORS, unit } from '@hcr/ui'

import { ButtonBuyAccommodation, Metadata, OwnerBuyAccommodationDrawer } from '../../common'

import { LayoutBooking } from './common'

export const BookingEmpty: FC = () => {
  const { t } = useTranslation()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const openDrawer = () => setIsDrawerOpen(true)
  const closeDrawer = () => setIsDrawerOpen(false)

  return (
    <LayoutBooking>
      <Metadata title={t('page-title.booking')} />
      <Header>
        <Box marginTop={unit(6.5)}>
          <Typography component='h1' variant='titleM'>
            {t('booking.no-accommodation')}
          </Typography>
        </Box>
        <Box marginTop={unit(3)}>
          <Typography component='h2' variant='bodyM'>
            {t('booking.no-bookings-in-the-destination')}
          </Typography>
        </Box>
        <Box marginTop={unit(7)}>
          <ButtonBuyAccommodation
            isDrawerOpen={isDrawerOpen}
            onClickOpenDrawer={openDrawer}
            variant='outlined'
            color='black'
          />
        </Box>
      </Header>
      <ContentDivider />

      <OwnerBuyAccommodationDrawer isOpen={isDrawerOpen} onClose={closeDrawer} />
    </LayoutBooking>
  )
}

const Header = styled(Stack)`
  align-items: stretch;
  padding: 0 ${unit(4)} ${unit(7)};
  text-align: center;
`

const ContentDivider = styled(Box)`
  background-color: ${COLORS.vaalea[500]};
  height: ${unit(0.25)};
  width: calc(100% + ${unit(6)});
  margin-left: ${unit(-3)};
`
